import { Inject, Pipe, PipeTransform } from '@angular/core'
import { LOGGER_SERVICE } from '../../logger/logger.config'
import { LoggerService } from '../../logger/logger.interface'
import { isValid, parseISO } from 'date-fns'

@Pipe({
  name: 'isoStringToDate'
})
export class IsoStringToDatePipe implements PipeTransform {
  public constructor(@Inject(LOGGER_SERVICE) private readonly log: LoggerService) {}

  /**
   * Convert a ISO8601 Datetime string into a Javascript Date object.
   *
   * @remarks
   * This is meant to be a stopgap tool to allow us to start writing components
   * which take Date as inputs instead of passing date strings around the app.
   * Date is a stronger type which will help avoid issues with bad string
   * parsing which used to plague us. The goal is to eventually eliminate this
   * pipe completely, and instead convert strings to dates as soon as they are
   * fetched in our Data Services.
   */
  transform(s: string): Date {
    const d = parseISO(s)

    // Log problems, but do not interfere with data flow
    if (!isValid(d)) {
      this.log.error('Invalid ISO date string passed to pipe.', {
        pipe: 'IsoStringToDatePipe',
        string: s
      })
    }

    return d
  }
}
